import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'
import type { Ref } from 'vue'
import { unref } from 'vue'
import type { Event, EventRequest, PatchedEventRequest } from '@openapi'
import { usePitcherApi } from '@sdk/main'
import type { EventsFetchRequest } from '@lib/types/sfdc'
import { fetchAll } from '@lib/util/network'

export const useFetchEvents = (params: Ref<EventsFetchRequest>, options?: { enabled?: boolean }) =>
  useQuery(['events'], () => fetchAll<Event>(usePitcherApi().getEvents, unref(params)), options)

export const useCreateEvent = () => {
  const queryClient = useQueryClient()

  return useMutation((props: EventRequest) => usePitcherApi().createEvent(props), {
    onSuccess: (newEvent) => {
      queryClient.setQueryData(['events'], (events?: Event[] | null) => [...(events ?? []), newEvent])
    },
  })
}

export const useDeleteEvent = () => {
  const queryClient = useQueryClient()

  return useMutation((props: Event) => usePitcherApi().deleteEvent(props), {
    onSuccess: (_, props: any) => {
      queryClient.setQueryData(['events'], (events?: Event[] | null) =>
        events?.filter((event: Event) => event.id !== props.id),
      )
    },
  })
}

export const useUpdateEvent = () => {
  const queryClient = useQueryClient()

  return useMutation((props: PatchedEventRequest) => usePitcherApi().updateEvent(props), {
    onSuccess: (newEvent, props: any) => {
      queryClient.setQueryData(['events'], (events?: Event[] | null) => [
        ...(events?.filter((event) => event.id !== props.event_id) ?? []),
        newEvent,
      ])
    },
  })
}
